/* eslint-disable jira/filename-case */
import type { WorkspaceId } from '@jira/servicedesk__insight-common-types-shared-types/src/toCmdbObjectTypeId.tsx';
import { getCmdbRestBaseUrl } from './getCmdbRestBaseUrl.tsx';

/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/icon
 */
const getCmdbIconUrl = (workspaceId: WorkspaceId) => `${getCmdbRestBaseUrl(workspaceId)}/icon`;
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/icon/create
 */
export const getCmdbIconCreateUrl = (workspaceId: WorkspaceId): string =>
	`${getCmdbIconUrl(workspaceId)}/create`;
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/icon/token-for-fetching-icon/${fileUuid}
 */
export const getCmdbIconTokenFetchingUrl = (workspaceId: WorkspaceId, fileUuid: string): string =>
	`${getCmdbIconUrl(workspaceId)}/token-for-fetching-icon/${fileUuid}`;
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/icon/token-for-uploading-icon
 */
export const getCmdbIconTokenUploadingUrl = (workspaceId: WorkspaceId): string =>
	`${getCmdbIconUrl(workspaceId)}/token-for-uploading-icon`;
/**
 * /gateway/api/jsm/assets/workspace/${workspaceId}/v1/icon/${iconId}
 */
export const getCmdbIconByIdUrl = (workspaceId: WorkspaceId, iconId: string): string =>
	`${getCmdbIconUrl(workspaceId)}/${iconId}`;
